/* Styles */
import "@/scss/main.scss";
import "@mdi/font/css/materialdesignicons.css";

/* Core */
import Buefy from "buefy";
import Vue from "vue";

/* Sentry */
import * as Integrations from "@sentry/integrations";
import * as Sentry from "@sentry/browser";

if (process.env.VUE_APP_SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_KEY,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  });
}

/* Router & Store */
import router from "@/router";
import store from "@/store";

/* Vue. Main component */
import App from "@/App.vue";

/* Vue. Component in recursion */
import AsideMenuList from "@/components/AsideMenuList.vue";

/* API */
import VueAxios from "vue-axios";
import axios from "axios";

/* i18n */
import i18n from "@/i18n";

// Setup the Bulma UI library
Vue.use(Buefy);

// Install the API library
Vue.use(VueAxios, axios);

/* Collapse mobile aside menu on route change */
router.afterEach(() => {
  store.commit("asideMobileStateToggle", false);
  store.commit("overlayToggle", false);
  store.commit("asideActiveForcedKeyToggle", null);
});

Vue.config.productionTip = false;

/* These components are used in recursion algorithm */
Vue.component("AsideMenuList", AsideMenuList);

new Vue({
  router,
  store,
  i18n,
  mounted: () => {
    document.documentElement.classList.remove("has-spinner-active");
  },
  render: h => h(App)
}).$mount("#app");
